import moment from "moment";

export const dateFormat = (val: any) => {
    return moment(val).format("DD/MM/YYYY");
};
